import { z } from "zod";
import { CompanyIdQuerySchema, IsoDateSchema, QueryBooleanSchema } from "./common.js";
import { CASE_STATUSES, EXPORT_PRESETS } from "../constants/index.js";

/**
 * 진실의 원천: harness/API-SPEC.md §10, docs/01_아키텍처와_데이터모델.md §9 ★ 엑셀 다운로드
 * 서버는 JSON 행만 돌려준다 — xlsx 조립은 브라우저(SheetJS)가 한다 (Workers CPU 10ms 보호).
 */

export const ExportQuerySchema = z.object({
  // `format` 은 두지 않는다. 서버는 **JSON 행만** 돌려주고 파일 조립은 브라우저가 한다 —
  // 서버가 만들지 않는 형식을 질의로 받으면, 계약이 없는 기능을 약속하는 것이 된다.
  preset: z.enum(EXPORT_PRESETS).default("manager"),
  from: IsoDateSchema.optional(),
  to: IsoDateSchema.optional(),
  company: CompanyIdQuerySchema,
  status: z.enum(CASE_STATUSES).optional(),
  // 개인정보(담당자·연락처) 포함 여부 — 기본은 포함 안 함 (harness/API-SPEC.md §10)
  pii: QueryBooleanSchema.default(false),
});
export type ExportQuery = z.infer<typeof ExportQuerySchema>;

// "부장님 보고용" 프리셋 열 순서 그대로 (docs/01 §9-2)
export const ManagerExportRowSchema = z.object({
  일자: z.string(),
  업체이름: z.string(),
  시리얼: z.string(),
  담당자: z.string().nullable(), // pii=0 이면 서버가 이 필드 자체를 응답에서 제거한다
  연락처: z.string().nullable(),
  비고: z.string().nullable(),
  출고일자: z.string().nullable(),
  행선지: z.string().nullable(),
  송장번호: z.string().nullable(),
  비고2: z.string().nullable(),
  교체시리얼: z.string().nullable(),
  SECUI접수번호: z.string().nullable(),
  SECUI진행상태: z.string().nullable(),
  승인일시: z.string().nullable(),
  현재상태: z.string(),
});
export type ManagerExportRow = z.infer<typeof ManagerExportRowSchema>;

export const ExportRowsResponseSchema = z.object({
  preset: z.enum(EXPORT_PRESETS),
  pii_included: z.boolean(),
  rows: z.array(z.record(z.string(), z.unknown())),
});
export type ExportRowsResponse = z.infer<typeof ExportRowsResponseSchema>;
